export enum TechnologySignalAllFiltersKey {
    Technologies = "technologies",
    TechnologyCategories = "technologyCategories",
    TechnologySubCategories = "technologySubCategories",
    PeriodAmount = "periodAmount",
}

export enum TechnologySignalTechnologiesFiltersKey {
    Technologies = "technologies",
    TechnologyCategories = "technologyCategories",
    TechnologySubCategories = "technologySubCategories",
}
